// extracted by mini-css-extract-plugin
export default {"list":"TodoList_list__4W8Q7","item":"TodoList_item__DB2s0","done":"TodoList_done__99XoP"};